import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectDataUser } from 'connect/selectors';

/**
 * A custom hook that determines if the current user is a partner user.
 * A partner user can create patients and appointments for other users.
 */
export const useIsPartnerUser = () => {
  const user = useSelector(selectDataUser);
  return useMemo(() => !!user?.partner, [user?.partner]);
};
